import { useEffect, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";
import { getCheckoutSessionSummary } from "@/services/payments";
import { BrandLogo } from "@/components/BrandLogo";

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

const SubscribeSuccess = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");
  const hasFired = useRef(false);

  useEffect(() => {
    if (hasFired.current) return;
    hasFired.current = true;

    if (!sessionId) return;

    getCheckoutSessionSummary(sessionId)
      .then(data => {
        window.gtag?.("event", "purchase", {
          transaction_id: data.sessionId,
          value: data.amountTotal,
          currency: data.currency,
          items: [
            {
              item_id: data.priceId,
              item_name: data.planName,
              price: data.amountTotal,
              quantity: 1,
            },
          ],
        });
      })
      .catch(() => {
        window.gtag?.("event", "purchase", {
          transaction_id: sessionId,
          value: 0,
          currency: "USD",
          items: [{ item_name: "RecruitAI Subscription", quantity: 1 }],
        });
      });
  }, [sessionId]);
  return (
    <div className="min-h-screen w-full bg-background flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-md space-y-6">
        <div className="text-center">
          <h1>
            <BrandLogo className="mx-auto h-11 w-auto" />
          </h1>
        </div>

        <Card>
          <CardContent className="pt-6 text-center space-y-4">
            <CheckCircle2 className="h-16 w-16 text-green-500 mx-auto" />
            <h2 className="text-2xl font-semibold">You're all set!</h2>
            <p className="text-muted-foreground">
              Check your email to set up your password and get started.
            </p>
            <Button asChild variant="outline" className="w-full">
              <Link to="/">Already set up? Log in</Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default SubscribeSuccess;
